import {GET_ADMINUSER, GET_ADDADMINUSER, GET_UPDATEADMINUSER } from "resources/actionTypes";

const initialState = {
  loading: false,
  error: null,
  adminUser: [],
};

const initialStateAdd = {
  userAddAdminUser: [],
  loading: false,
  error: null,
};
const initialStateUpdate = {
  userUpdateAdminUser: [],
  loading: false,
  error: null
}

export const getAdminUser = (
  state = initialState,
  action
) => {

  switch (action.type) {
    case GET_ADMINUSER.GET_ADMINUSER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADMINUSER.GET_ADMINUSER_SUCCESS:
      return {
        ...state,
        loading: false,
        adminUser: action.adminUser,
      };
    case GET_ADMINUSER.GET_ADMINUSER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export function userAddAdminUser(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDADMINUSER.GET_ADDADMINUSER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDADMINUSER.GET_ADDADMINUSER_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddAdminUser: action.userAddAdminUser,
      };
    case GET_ADDADMINUSER.GET_ADDADMINUSER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateAdminUser(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATEADMINUSER.GET_UPDATEADMINUSER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATEADMINUSER.GET_UPDATEADMINUSER_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateAdminUser: action.userUpdateAdminUser,
      };
    case GET_UPDATEADMINUSER.GET_UPDATEADMINUSER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}